
import React from "react";
import CommunicationSubscribersTab from "@/components/admin/communication-hub/CommunicationSubscribersTab";

const CommunicationSubscribersManagement: React.FC = () => {
  return <CommunicationSubscribersTab />;
};

export default CommunicationSubscribersManagement;
